import { FEEDBACK_COOKIE_NAME } from './constants';

/**
 * The one cookie this app uses: `chk_te_feedback`, which suppresses the feedback prompt
 * once a user has answered it (feedback.jsx:9, :47-48).
 *
 * Read and written exactly as the original did — a substring check on `document.cookie`
 * and a raw assignment with the same far-future expiry. It carries no identity and is
 * never sent anywhere; it is a client-side "don't ask again" flag.
 */

export function hasAnsweredFeedback(): boolean {
  return document.cookie.includes(`${FEEDBACK_COOKIE_NAME}=true`);
}

export function markFeedbackAnswered(): void {
  // The original's literal expiry — the maximum Oracle-era date, i.e. "never".
  document.cookie = `${FEEDBACK_COOKIE_NAME}=true; expires=Tue, 31 Dec 4712 23:59:59 GMT`;
}
